// Ticker
jQuery(document).ready(function ($) {
    //$("#ticker").ready(function () {
    if ($('#ticker').length) {

        $("#ticker").ticker({
            dataUrl: 'https://vp254.alertir.com/afw/data/',
            language: 'sv',
            instrument: [{
                id: 'MDA:5547',
                name: 'SVIK'
            }],
            decimalPoints: 1,
            autoUpdate: 60,

            template: function (data) {

                function getDateDescription(d1, d2) {
                    if (d1.toDateString() === d2.toDateString()) {
                        return 'Today';
                    }

                    d1.setDate(d1.getDate() - 1);
                    if (d1.toDateString() === d2.toDateString()) {
                        return d2;
                    }

                    return moment.tz(d2, "Europe/Stockholm").format('YYYY-MM-DD');
                }

                function getTimeString(d) {
                    return moment.tz(d, "Europe/Stockholm").format('HH:mm');
                }

                function isNoDataTime(d) {
                    const dayOfWeek = d.getDay();
                    const time = getTimeString(d);

                    if (dayOfWeek === 0 || dayOfWeek === 6 || (dayOfWeek >= 1 && dayOfWeek <= 5 && time >= '00:00' && time < '09:00')) {
                        return true;
                    }

                    return false;
                }

                function getFormattedDateTime(data) {
                    const now = new Date();
                    const dataDate = new Date(data.value.date * 1000);

                    if (data.isFallback || isNoDataTime(now)) {
                        return 'Latest';
                    } else {
                        return getDateDescription(now, dataDate) + ' ' + getTimeString(dataDate);
                    }
                }

                const isPositiveDiff = data.formatted.diff > 0;
                const pos = isPositiveDiff ? '+' : '';
                const last = data.formatted.last;
                const diff = data.formatted.diff;
                const diffpercent = data.value.diffpercent ? ` (${data.formatted.diffpercent}%)` : '';
                const formattedDateTime = getFormattedDateTime(data);

                let title = "The Studsvik Share";


                return `<div class="title"><strong>${title} – ${formattedDateTime}</strong></div>` +
                    `<div class="stock-tick__img"></div>` +
                    `<div class="rate"><span>${data.formatted.last} SEK</span>` +
                    `${pos}${diff} SEK ${diffpercent}</div>`;

            }
        });
    }
});

function decodeHTML(text) {
    var textArea = document.createElement('textarea');
    textArea.innerHTML = text;
    return textArea.value;
}

<!-- end Simple Custom CSS and JS -->

//# sourceMappingURL=ticker.js.map
